import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hmxkckbcslzxsssmfcmz.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhteGtja2Jjc2x6eHNzc21mY216Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc4Mzg5NzIsImV4cCI6MjA2MzQxNDk3Mn0.IZZrjriahG13YmOz-LCzyOfwAqMQRVkjAlpr3qUDHdI';

export const supabase = createClient(supabaseUrl, supabaseKey);
